import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
export default class AddFriendConfirmModal extends Modal {
  loading = false;
  className() {
    return 'FriendshipConfirmModal Modal--small';
  }
  title() {
    return app.translator.trans('forumaker-friendship.forum.add_modal.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("p", {
      className: "FriendshipConfirmModal-text"
    }, app.translator.trans('forumaker-friendship.forum.add_modal.text', {
      user: this.attrs.user
    })), m("div", {
      className: "FriendshipConfirmModal-actions"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      icon: "fas fa-user-plus",
      loading: this.loading,
      onclick: () => this.send()
    }, app.translator.trans('forumaker-friendship.forum.add_modal.confirm_btn')), m(Button, {
      className: "Button Button--block",
      disabled: this.loading,
      onclick: () => this.hide()
    }, app.translator.trans('forumaker-friendship.forum.add_modal.cancel_btn'))));
  }
  async send() {
    this.loading = true;
    m.redraw();
    try {
      const response = await app.request({
        method: 'POST',
        url: `${app.forum.attribute('apiUrl')}/friendship-requests`,
        body: {
          recipientId: this.attrs.user.id()
        }
      });
      this.attrs.user.pushAttributes({
        friendshipHasPendingOutgoing: response.status === 'requested',
        friendshipIsFriend: response.status === 'auto_accepted'
      });

      // Mutual-request auto-accept: a friendship was created immediately,
      // so both friendCount totals need to reflect that right away — no
      // response body carries updated user resources for this endpoint.
      if (response.status === 'auto_accepted') {
        this.attrs.user.pushAttributes({
          friendCount: (this.attrs.user.attribute('friendCount') || 0) + 1
        });
        app.session.user?.pushAttributes({
          friendCount: (app.session.user.attribute('friendCount') || 0) + 1
        });
      }
      this.hide();
      this.attrs.onSent?.();
      app.alerts.show({
        type: 'success'
      }, app.translator.trans(response.status === 'auto_accepted' ? 'forumaker-friendship.forum.requests_modal.accept_success' : 'forumaker-friendship.forum.add_modal.success'));
    } catch (error) {
      this.loading = false;
      m.redraw();
      throw error;
    }
  }
}
flarum.reg.add('forumaker-friendship', 'forum/components/AddFriendConfirmModal', AddFriendConfirmModal);